module.exports = __webpack_public_path__ + "img/car.7347c6cb.jpg";